import React from 'react'
import { Link } from 'react-router-dom'

const docs = [
  { path: 'terms.md', label: 'Terms of Service' },
  { path: 'privacy.md', label: 'Privacy Policy' },
  { path: 'refund-policy.md', label: 'Refund Policy' },
  { path: 'membership-policy.md', label: 'Membership Policy' },
  { path: 'content-guidelines.md', label: 'Content Guidelines' },
  { path: 'display-agreement.md', label: 'Display Agreement' },
  { path: 'submission-disclosure.md', label: 'Submission Disclosure' },
  { path: 'attribution-branding.md', label: 'Attribution & Branding' },
]

export default function Legal() {
  return (
    <section className="legal-doc">
      <h1 className="text-3xl font-bold mb-4">Legal Documents</h1>
      <ul className="list-decimal list-inside space-y-3 text-lg leading-relaxed">
        {docs.map((doc) => {
          const id = doc.path.replace(/\.md$/, '')
          return (
            <li key={doc.path}>
              <Link to={`/legal/${id}`} className="text-primary underline hover:text-primary-hover font-medium">
                {doc.label}
              </Link>
            </li>
          )
        })}
      </ul>
    </section>
  )
}